import React from 'react';
import { CircularProgressbar, CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const ScoreComponent = ({ scores, mandatoryCount = 5, optionalCount = 12, bonusCount = 2 }) => {
    const score = scores.score;
    const scoreMandatory = scores.scoreMandatory;
    const scoreOptional = scores.scoreOptional;
    const scoreBonus = scores.scoreBonus;

    return (
        <div className="d-flex align-items-center mb-2">
            <div className="me-2" style={{width: '140px'}}>

                <CircularProgressbarWithChildren
                    value={mandatoryCount ? (scoreMandatory / mandatoryCount * 100) : 0}
                    text={`${score}%`}
                    styles={buildStyles({
                        pathColor: `#DC3545`,
                        textColor: '#FFFFFF',
                        trailColor: 'rgba(220, 53, 70, 0.15)',
                        backgroundColor: '#007FA5',
                        text: {fill: '#fff'},
                    })}
                >
                    <div style={{ width: "84%", borderRadius: '50%' }}>
                        <CircularProgressbarWithChildren
                            value={optionalCount ? (scoreOptional / optionalCount * 100) : 0}
                            styles={buildStyles({
                                pathColor: "#5CBC33",
                                trailColor: 'rgba(92, 188, 51, 0.15)',
                                text: {fill: '#fff'},
                            })}
                        >
                            <div style={{ width: "84%", borderRadius: '50%' }}>
                                <CircularProgressbar
                                    value={bonusCount ? (scoreBonus / bonusCount * 100) : 0}
                                    styles={buildStyles({
                                        pathColor: `#4693D8`,
                                        textColor: '#4e4e4e',
                                        trailColor: 'rgba(70, 147, 216, 0.15)',
                                        backgroundColor: '#007FA5',
                                        text: {fill: '#fff'},
                                    })}
                                />
                            </div>
                        </CircularProgressbarWithChildren>
                    </div>
                </CircularProgressbarWithChildren>
            </div>

            <div className="flex-grow-1">
                <div className="alert alert-light mb-2">
                    <small><i className="bi bi-record-circle-fill text-danger"></i> Un <strong>critère obligatoire</strong> rouge = score de 0 car non négociable pour la visibilité de votre page<br/><i className="bi bi-record-circle-fill text-success"></i> <strong>Critères complémentaires</strong> : arriver au meilleur score SEO possible, donc à une parfaite visibilité<br/><i className="bi bi-record-circle-fill text-info"></i> <strong>Critères bonus</strong> : permettent d'améliorer globalement les performances web de votre page<br/><strong>Il vous suffit de cliquer dessus pour savoir quoi faire !
                        </strong></small>
                </div>
            </div>

        </div>
    );
};

export default ScoreComponent;
